import { useState } from 'react';
import TopBar from '../../components/TopBar';
import { adminScan } from '../../api/endpoints';
import { hapticNotify, showScanQrPopup } from '../../lib/tg';

type ScanResult =
  | { kind: 'ok'; user_phone: string; user_username?: string; session_title: string; row_num: number; seat_num: number; sector_name: string }
  | { kind: 'used'; message: string }
  | { kind: 'invalid'; message: string };

export default function Scanner() {
  const [result, setResult] = useState<ScanResult | null>(null);
  const [busy, setBusy] = useState(false);

  async function scan() {
    setBusy(true);
    const payload = await showScanQrPopup();
    if (!payload) { setBusy(false); return; }
    try {
      const r = await adminScan(payload);
      setResult(r as ScanResult);
      hapticNotify((r as any).kind === 'ok' ? 'success' : 'error');
    } catch {
      setResult({ kind: 'invalid', message: 'Сервер недоступен' });
      hapticNotify('error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen pb-32">
      <TopBar title="Сканер QR" />
      <div className="px-4 pt-4">
        {!result && (
          <div className="text-muted text-sm mb-6 text-center">
            Наведите камеру на QR-код билета на входе.
          </div>
        )}
        {result?.kind === 'ok' && (
          <div className="card p-5 mb-4 bg-success/10 border border-success/30">
            <div className="text-success font-bold text-lg mb-2">Билет валиден</div>
            <div className="text-sm">{result.session_title}</div>
            <div className="text-sm">{result.sector_name} · ряд {result.row_num}, место {result.seat_num}</div>
            <div className="text-xs text-muted mt-2">{result.user_phone} {result.user_username ? ` · @${result.user_username}` : ''}</div>
          </div>
        )}
        {result?.kind === 'used' && (
          <div className="card p-5 mb-4 bg-warn/10 border border-warn/30">
            <div className="text-warn font-bold text-lg mb-1">Уже погашен</div>
            <div className="text-sm text-muted">{result.message}</div>
          </div>
        )}
        {result?.kind === 'invalid' && (
          <div className="card p-5 mb-4 bg-danger/10 border border-danger/30">
            <div className="text-danger font-bold text-lg mb-1">Билет не найден</div>
            <div className="text-sm text-muted">{result.message}</div>
          </div>
        )}
      </div>
      <div className="fixed bottom-0 inset-x-0 p-4 bg-bg border-t border-line">
        <button className="btn-primary" disabled={busy} onClick={scan}>
          {result ? 'Сканировать ещё' : 'Сканировать'}
        </button>
      </div>
    </div>
  );
}
